import React from "react";
import { NavLink } from "react-router-dom";
import { classnames, Icon } from "@culturehq/components";

const buttonClasses = ({ inverted, primary, small }) => classnames("Button", {
  "Button-inverted": inverted,
  "Button-primary": primary,
  "Button-small": small
});

const Anchor = ({
  to,
  icon,
  children,
  exact = false,
  activeClassName = undefined,
  ...classProps
}) => (
  <NavLink
    to={to}
    className={buttonClasses(classProps)}
    exact={exact}
    activeClassName={activeClassName}
  >
    {icon && <><Icon icon={icon} />{" "}</>}
    {children}
  </NavLink>
);

export default Anchor;
